<!-- ----------------------------------------------- -->
<template>
  <v-card flat class="rw-info-content">
    <v-list class="pa-0" v-for="(info, index) in riverWarnInfo" :key="index">
      <v-list-item @click="linkUrl(info.code, info.type)">
        <v-container>
          <v-row>
            <v-col :cols="7" class="pa-0">
              <div class="rw-info-type">
                {{ text.rwType.get(info.type) }}
              </div>
            </v-col>
            <v-col :cols="5" class="pa-0">
              <div class="rw-info-status" :class="jadgeKnd(info)">
                {{ info.kndNmS }}{{ getAlertLvl(info) }}
              </div>
            </v-col>
          </v-row>
          <v-row
            ><v-col :cols="7" class="pa-0">
              <div>
                <div>{{ info.name }}</div>
              </div>
            </v-col>
            <v-col :cols="5" class="pa-0">
              <div>
                {{ formatDateNonNull(info.annTime) }}
              </div>
            </v-col>
          </v-row>
          <v-row
            ><v-col v-if="isPcMode" :cols="12" class="pa-0">
              <div class="river-heading">
                {{ info.heading }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-list-item>
      <v-divider></v-divider>
    </v-list>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 MB用河川予警報一覧カード
 * MapRiverWarnInfo.vue
 * @author LIS
 */
import mixin from "./../../lib/mixin.js";
import Util from "./../../lib/util.js";
export default {
  name: "map-mb-river-warn-info",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        rwTitle: "発表情報一覧",
        rwType: new Map([
          ["fldfr", "洪水予報"],
          ["evstg", "水位周知河川情報"],
          ["damdsch", "ダム放流通知"],
          ["fldctl", "水防警報"],
        ]),
      },
    };
  },
  /** 算出部 */
  computed: {
    /** 河川予警報情報 */
    riverWarnInfo: {
      get() {
        return this.$store.state.map.riverWarnInfo;
      },
    },
    /** 表示コンテンツ */
    content: {
      get() {
        return this.$store.state.app.content;
      },
    },
    /** 観測所選択 */
    selectedTm: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /** モード */
    isPcMode: {
      get() {
        return this.$store.state.app.mode == "pc";
      },
    },
    /** LV.相当*/
    alertLvl: {
      get() {
        return this.$store.state.app.config.messageConfig.alertLvl;
      },
    },
  },
  /** メソッド */
  methods: {
    /** 河川予警報情報を閉じる */
    closeInfo() {
      this.$store.commit("map/hideInfoRw");
    },
    /** 河川予警報クリック時の処理 */
    linkUrl(code, type) {
      switch (type) {
        case "fldfr":
          type = 10;
          break;
        case "evstg":
          type = 11;
          break;
        case "fldctl":
          type = 20;
          break;
        case "damdsch":
          type = 30;
          break;
        default:
          return;
      }
      // ストアに予警報ID、予警報タイプを設定
      this.$store.commit("RiverWarn/setSelectedWarnReq", {
        cd: code,
        type: type,
      });
      // 河川予警報画面に遷移
      if (this.$store.state.app.mode == "pc") {
        this.routerPushRw("/pc/rw");
      } else {
        this.routerPushRw("/mb/rwdetail");
      }

      this.$store.commit("map/hideInfoRw");
    },
    /** 種別名 背景・文字色判定 */
    jadgeKnd(info) {
      if (info.type === "evstg" || info.type === "fldfr") {
        if (info.lvl === 90) {
          return "text-flood-occurrence";
        } else if (info.lvl === 80) {
          return "text-flood-danger";
        } else if (info.lvl === 60) {
          return "text-flood-refuge";
        } else if (info.lvl === 30) {
          return "text-flood-warn";
        }
      } else if (info.type === "damdsch") {
        if (info.lvl === 70) {
          return "text-damdsch-disasteroperating";
        } else if (info.lvl === 50) {
          return "text-damdsch-riserving";
        } else if (info.lvl === 0) {
          return "text-damdsch-normal";
        }
      } else if (info.type === "fldctl") {
        if (info.lvl === 40) {
          return "text-fldctl-dispatch";
        } else if (info.lvl === 20) {
          return "text-fldctl-preparation";
        } else if (info.lvl === 10) {
          return "text-fldctl-standby";
        }
      }
      return "";
    },
    /** 日付フォーマット */
    formatDateNonNull(val1) {
      return val1 == null ? "" : Util.formatDate24(val1);
    },
    /** レベル相当のテキスト */
    getAlertLvl(info) {
      let alertLvl = "";
      if (info.type === "fldfr" || info.type === "evstg") {
        switch (info.lvl) {
          case 30:
            alertLvl = this.alertLvl.fldfrLvl2;
            break;
          case 60:
            alertLvl = this.alertLvl.fldfrLvl3;
            break;
          case 80:
            alertLvl = this.alertLvl.fldfrLvl4;
            break;
          case 90:
            alertLvl = this.alertLvl.fldfrLvl5;
            break;
        }
      }
      return " " + alertLvl;
    },
  },
  /** 監視部 */
  watch: {
    content() {
      // 観測所画面から離れた場合は閉じる
      this.$store.commit("map/hideInfoRw");
    },
    selectedTm() {
      // 観測所選択が変更された場合は閉じる
      this.$store.commit("map/hideInfoRw");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/color.scss";
@import "./../../scss/kwb.scss";

.rw-info-content {
  font-size: 0.75rem;
  .rw-info-type {
    width: 130px;
    padding: 4px 8px 4px 8px;
    border: solid 1px $color-rw-type-border;
    border-radius: 8px;
    text-align: center;
  }
  .rw-info-status {
    padding: 4px 8px 4px 8px;
    border-radius: 8px;
    display: inline-block;
  }
}
</style>
